import ContenutoEffect from "./ContenutoEffect";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import IStore from "../../models/IStore";
import ContenutoModel from "./models/ContenutoModel";

type ActionUnion = undefined | HttpErrorResponseModel | ContenutoModel;

export default class ContenutoAction {
    public static readonly REQUEST_CONTENUTO_GET: string = "ContenutoAction.REQUEST_CONTENUTO_GET";
    public static readonly REQUEST_CONTENUTO_GET_FINISHED: string = "ContenutoAction.REQUEST_CONTENUTO_GET_FINISHED";

    public static contenutoGet(codice: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<any> => {
            return await ActionUtility.createThunkEffect<ContenutoModel>(
                dispatch,
                ContenutoAction.REQUEST_CONTENUTO_GET,
                ContenutoEffect.contenutoGet,
                codice
            );
        };
    }
}
